import Chart from "chart.js";
import axios from "axios";
export function ChartWilayah() {
  let dashboardUrl = "seller/dashboard";
  axios
    .get(dashboardUrl)
    .then((response) => {
      return response.data.data.chartStatistic.areaDistribution;
    })
    .then((data) => {
      var draw = Chart.controllers.pie.prototype.draw;
      Chart.controllers.pie = Chart.controllers.pie.extend({
        draw: function() {
          draw.apply(this, arguments);
        },
      });
      var ctx = document.getElementById("wilayahChart");

      var resWillName = data.label;
      var resWillData = data.value;
      // console.log(data.value);

      // function getRandonPastelColor() {
      //   const hue = Math.floor(Math.random() * 360);
      //   const randomColor = `hsl(${hue}, 40%, 40%)`;
      //   return randomColor;
      // }

      // function getColorArray() {
      //   let colorArray = [];
      //   for (let i = 0; i < resWillData.length; i++) {
      //     const newColorIndex = getRandonPastelColor();
      //     if (colorArray.includes(newColorIndex)) {
      //       i = i - 1;
      //     } else {
      //       colorArray.push(newColorIndex);
      //     }
      //   }
      //   return colorArray;
      // }
      // getColorArray();

      Chart.defaults.global.defaultFontColor = "#dddddd";
      new Chart(ctx, {
        type: "pie",
        data: {
          labels: resWillName,
          datasets: [
            {
              lineTension: 0,
              label: "Qty",
              data: resWillData,
              backgroundColor: [
                "#5C5552",
                "#19323C",
                "#A93F55",
                "#534B62", //red
                "#8C5E58",
                "#351f39",
              ],
              borderColor: "transparent",
              borderWidth: 1,
            },
          ],
        },
        options: {
          scales: {
            xAxes: [
              {
                ticks: {
                  display: false,
                },
                gridLines: {
                  display: false,
                  drawBorder: false,
                },
              },
            ],
            yAxes: [
              {
                ticks: {
                  display: false,
                },
                gridLines: {
                  display: false,
                  drawBorder: false,
                },
              },
            ],
          },
          maintainAspectRatio: false,
          legend: {
            display: false,
            position: "bottom",
          },
          tooltips: {
            bodySpacing: 4,
            mode: "nearest",
            intersect: 0,
            position: "nearest",
            xPadding: 10,
            yPadding: 10,
            caretPadding: 10,
          },
        },
        // options: {
        //     plugins: {
        //         labels: {
        //             render: 'label',
        //             position: 'outside',
        //             fontSize: 9.5,
        //             textMargin: 5,
        //             // fontColor: 'rgb(231, 231, 231)',
        //         },
        //     },
        //     maintainAspectRatio: false,
        //     legend: {
        //         display: false,
        //         position: 'bottom'
        //     },
        //     tooltips: {
        //         bodySpacing: 4,
        //         mode: "nearest",
        //         intersect: 0,
        //         position: "nearest",
        //         xPadding: 10,
        //         yPadding: 10,
        //         caretPadding: 10,
        //         callbacks: {
        //             label: function (tooltipItem, data) {
        //                 var label = data.labels[tooltipItem.index];
        //                 var val = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
        //                 return `${label}, Qty : ${val}`;
        //             }
        //         },
        //     },
        //     responsive: true,
        // }
      });
    });
}
